export default "__VITE_ASSET__6e1520cd__"